<ng-template #modalContent>
  <!-- Angular Material Dialogs have a close animation which causes the templates to stay active for a short         -->
  <!-- while after close() is called. This breaks some modals as their template binds to properties that are deleted -->
  <!-- right when close() is called.                                                                                 -->
  @if (opened) {
    <dt-modal-content (closeClick)="close()"></dt-modal-content>
  }
</ng-template>
